import firebase from "firebase/app";
import "firebase/analytics";

var firebaseConfig = {
  apiKey: "AIzaSyDBFBejvqxsYwa0ba17ynyUTTXHo6i2FOs",
  authDomain: "palaceofkebap-36ee0.firebaseapp.com",
  projectId: "palaceofkebap-36ee0",
  storageBucket: "palaceofkebap-36ee0.firebasestorage.app",
  messagingSenderId: "614300283441",
  appId: "1:614300283441:web:3bae7880e79168aacb5b10",
  measurementId: "G-PRTQBQZYEP",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

var analytics = null;
try {
  analytics = firebase.analytics();
  analytics.setUserProperties({ platform: "web" });
} catch (e) {
  // Analytics init failed silently
}

function safe(fn) {
  if (analytics) {
    try {
      fn();
    } catch (e) {
      // silently fail
    }
  }
}

export function logViewItem(item) {
  safe(function () {
    analytics.logEvent("view_item", {
      currency: "EUR",
      value: item.price,
      items: [
        {
          item_id: item.id || item.objectID,
          item_name: item.title,
          item_category: (item.category && item.category.title) || "",
          price: item.price,
        },
      ],
    });
  });
}

export function logAddToCart(item, quantity) {
  safe(function () {
    analytics.logEvent("add_to_cart", {
      currency: "EUR",
      value: item.price * quantity,
      items: [
        {
          item_id: item.id || item.objectID,
          item_name: item.title,
          item_category: (item.category && item.category.title) || "",
          price: item.price,
          quantity: quantity,
        },
      ],
    });
  });
}

export function logBeginCheckout(cartItems, total) {
  safe(function () {
    analytics.logEvent("begin_checkout", {
      currency: "EUR",
      value: total,
      items: cartItems.map(function (item) {
        return {
          item_id: item.id || item.objectID,
          item_name: item.title,
          price: item.price,
          quantity: item.quantity,
        };
      }),
    });
  });
}

export function logAddPaymentInfo(paymentMethod, total) {
  safe(function () {
    analytics.logEvent("add_payment_info", {
      currency: "EUR",
      value: total,
      payment_type: paymentMethod,
    });
  });
}

export function logPurchase(orderId, cartItems, total, paymentMethod) {
  safe(function () {
    analytics.logEvent("purchase", {
      currency: "EUR",
      value: total,
      transaction_id: orderId,
      items: cartItems.map(function (item) {
        return {
          item_id: item.id || item.objectID,
          item_name: item.title,
          price: item.price,
          quantity: item.quantity,
        };
      }),
    });
  });
}

export function logPageView(pageName) {
  safe(function () {
    analytics.logEvent("page_view", { page_title: pageName });
  });
}

export default analytics;
